import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
import { CheckoutButton } from '../CheckoutButton';
export function TestimonialsSection() {
  return <section className="bg-sand-50 px-4 py-14 sm:py-20" data-id="element-300" data-mp="1rv633cjw4jbh">
      <div className="mx-auto w-full max-w-5xl" data-id="element-301" data-mp="1rtl3v9mmsc7a">
        <div className="text-center" data-id="element-302" data-mp="1mxcs867n714v">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-303" data-mp="1mwba5hs7ledn">
            ⭐ What students are saying
          </p>
          <h2 className="mt-3 font-display text-[26px] font-bold leading-[1.14] tracking-tight text-navy-900 sm:text-4xl" data-id="element-304" data-mp="1dvdcrica0541">
            A clearer way to review Prosthodontics
          </h2>
          <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-card ring-1 ring-navy-800/8" data-id="element-305" data-mp="13xyx3ky6fkcs">
            <span className="flex gap-0.5" aria-hidden="true" data-id="element-306" data-mp="339jjxxg87yi0">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-307" data-mp="2ycjbxgztglo9" data-mpi={i} />)}
            </span>
            <span className="text-[13px] font-extrabold text-navy-900" data-id="element-308" data-mp="1tbzu92u71720">4.9/5</span>
          </div>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-309" data-mp="1jbh6vy3f78fc">
          {testimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-2xl bg-white p-5 shadow-card ring-1 ring-navy-800/8" data-id="element-310" data-mp="1oa0qvsygea52">
              <span className="flex gap-0.5" aria-hidden="true" data-id="element-311" data-mp="2c2h9c4m3s44w">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-312" data-mp="22aldl07hoq3u" data-mpi={i} />)}
              </span>
              <blockquote className="mt-3 text-[14.5px] leading-relaxed text-navy-800/80" data-id="element-313" data-mp="2783miqlib5bu">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-314" data-mp="2ux609nd0se12">
                <img src={t.photo} alt={`Photo of ${t.name}`} loading="lazy" className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-aqua-200" data-id="element-315" data-mp="2zr0jyqsmkt05" />
                <span className="text-[14px] font-extrabold text-navy-900" data-id="element-316" data-mp="30khznn51feze">
                  {t.name} <span aria-hidden="true" data-id="element-317" data-mp="2vlwvjcmo0b5o">{t.flag}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center text-[12px] text-navy-800/45" data-id="element-318" data-mp="2qoemlm8ndvxo">
          Replace these example testimonials with verified customer reviews before publishing.
        </p>

        <div className="mt-8" data-id="element-319" data-mp="2gy2562w4qivr">
          <CheckoutButton label="I want these results too" sub="$27 one-time · 7-Day Guarantee" data-id="element-320" data-mp="2gxa9ks2j8l5h" />
        </div>
      </div>
    </section>;
}